import { useColorMode, useColorStyle, useTheme } from '@tonic-one/react';

function useSenderListStyle() {
  const theme = useTheme();
  const [colorMode] = useColorMode();
  const [colorStyle] = useColorStyle({ colorMode });
  const { colors } = useTheme();
  const borderColor = (
    {
      dark: 'gray:60',
      light: 'gray:30',
    } as any
  )[colorMode];
  const borderColorValue = theme.colors[borderColor] || borderColor;
  const flexListStyle = {
    appearance: 'none',
    border: '0.0625rem solid',
    color: colors[colorStyle.color.primary],
    outline: 0,
    position: 'relative',
    transition: 'all .2s',
    borderRadius: '3px',
    fontSize: '14px',
    lineHeight: '20px',
    paddingLeft: '12px',
    paddingRight: '12px',
    paddingTop: '12px',
    paddingBottom: '5px',
    // width: '100%',
    backgroundColor: colorStyle.background.secondary,
    overflow: 'auto',
    borderColor: borderColorValue,
  };
  const descriptionStyle = {
    color: colors[colorStyle.color.secondary],
    fontSize: '14px',
    lineHeight: '20px',
    marginTop: '2px',
    marginBottom: '16px',
  };
  // console.log(descriptionStyle);
  return {
    flexListStyle,
    descriptionStyle,
  };
}

export default useSenderListStyle;
